export default __webpack_public_path__ + "static/media/nahitajitz-logo.29ea94ef.jpg";